// extracted by mini-css-extract-plugin
export default {"headingContainer":"Partner_headingContainer__4qnKc","partner":"Partner_partner__6mfxw"};